import { render } from "./HeroiconsOutlineNewspaper.vue?vue&type=template&id=1ff0b882"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineNewspaper.vue"]])

export default __exports__